import './About.scss';
import profilpic from '../assets/pp1.jpg';

const About = () => (
  <section className="about" id="about">
    <span className="about__label">02</span>

    <div className="about__left">
      <h2 className="about__title">
        UX/UI DESIGNER,<br />
        D.A &amp; GRAPHISTE<br />
        SENIOR
      </h2>
    </div>

    <div className="about__content">
      <p>
        Depuis toujours, je suis animé par la même curiosité : comprendre pourquoi certaines idées captent l'attention, créent de l'émotion ou restent en mémoire. C'est cette fascination pour l'image, le design et la communication qui m'a conduit vers les métiers de la création.
      </p>
      <p>
        Depuis plus de quinze ans, j'accompagne des projets aux univers très différents, en agence, en entreprise comme en indépendant. Cette diversité m'a permis de développer une approche à la fois créative et stratégique, où chaque décision de design répond à un objectif précis.
      </p>
      <p>
        Au cours de mon parcours, notamment chez <strong>eYeka</strong>, j'ai eu l'opportunité de travailler sur des campagnes et des projets liés à des marques internationales telles que P&amp;G, Unilever, Nestlé, Danone ou PepsiCo. Une expérience qui m'a appris à naviguer entre des problématiques variées, à comprendre rapidement les enjeux d'une marque et à concevoir des solutions adaptées à des publics très différents.
      </p>
      <p>
        Aujourd'hui, qu'il s'agisse d'une identité visuelle, d'un packaging, d'un site web ou d'une interface digitale, mon rôle reste le même : transformer une idée, une vision ou un besoin en une expérience cohérente, utile et mémorable.
      </p>
    </div>

    <div className="about__photo">
      <img src={profilpic} alt="Fabien Bazire" />
    </div>
  </section>
);

export default About;
